import * as React from "react";

const SvgMosc = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200.66"
    fill="none"
    viewBox="0 0 120 70"
    {...props}
  >
    <path fill={rackColor} d="M0 0h120v70H0z"></path>
    <path
     d="M0 0h120v70H0z"
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
    <path fill="#D7EAFF" d="M5 5h110v60H5z"></path>
    <path fill={rackColor} d="M12 2h5v65h-5z"></path>
    <path
      fill={rackColor}
      d="M2 15v-5h116v5zM2 25v-5h116v5zM2 35v-5h116v5zM2 45v-5h116v5zM2 55v-5h116v5zM2 65v-5h116v5z"
    ></path>
    <path
      fill={rackColor}
      d="M22 2h5v65h-5zM32 2h5v65h-5zM42 2h5v65h-5zM52 5h5v62h-5zM62 2h5v65h-5zM72 2h5v65h-5zM82 2h5v65h-5zM92 2h5v65h-5zM102 2h5v65h-5z"
    ></path>
  </svg>
);

export default SvgMosc;
